/**
 * @generated SignedSource<<b49a39e65e35df98b3700e967a45250a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type IssuesAndPullRequestsCount$data = {
  readonly issues: {
    readonly totalCount: number;
  };
  readonly pullRequests: {
    readonly totalCount: number;
  };
  readonly " $fragmentType": "IssuesAndPullRequestsCount";
};
export type IssuesAndPullRequestsCount$key = {
  readonly " $data"?: IssuesAndPullRequestsCount$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssuesAndPullRequestsCount">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "totalCount",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssuesAndPullRequestsCount",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IssueConnection",
      "kind": "LinkedField",
      "name": "issues",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PullRequestConnection",
      "kind": "LinkedField",
      "name": "pullRequests",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    }
  ],
  "type": "Label",
  "abstractKey": null
};
})();

(node as any).hash = "08593d3aead57b7938517357028a7ec0";

export default node;
